import AgoraRTM from 'agora-rtm-sdk'
import { Message } from 'element-ui'

export default class RTMClient {
  constructor (callBack) {
    this._client = null
    this._params = {}
    this.channels = {}
    this._callBack = callBack
    this.sourceMessageId = ''
    this.destinateMessageId = ''
  }

  handleEvents () {
    this._client.on('ConnectionStateChanged', (data, reason) => {
      if (reason === 'REMOTE_LOGIN') {
        this._callBack({
          action: 'REMOTE_LOGIN',
          payload: data
        })
      } else {
        this._callBack({
          action: 'ConnectionStateChanged',
          payload: data
        })
      }
    })
    this._client.on('MessageFromPeer', (...data) => {
      this._callBack({
        action: 'PeerMessage',
        payload: data
      })
    })
  }

  subscribeChannelEvents (id) {
    const channelEvents = [
      'ChannelMessage',
      'MemberJoined',
      'MemberLeft'
    ]
    channelEvents.forEach((eventName) => {
      this.channels[id].channel.on(eventName, (...args) => {
        this._callBack({
          action: eventName,
          payload: args
        })
      })
    })
  }

  async join (data) {
    this._client = AgoraRTM.createInstance(data.appId)
    this.handleEvents()

    this._params = data
    return this._client.login({
      uid: data.uid ? data.uid.toString() : '',
      token: data.token
    })
  }

  async logout () {
    return this._client.logout()
  }

  async joinChannel (data) {
    const channel = this._client.createChannel(data.id ? data.id.toString() : '')
    this.channels[data.id] = {
      channel,
      joined: false // channel state
    }
    this.subscribeChannelEvents(data.id)
    return channel.join()
  }

  async leaveChannel (id) {
    if (!this.channels[id] || (this.channels[id] && !this.channels[id].joined)) return
    return this.channels[id].channel.leave()
  }

  async sendPeerMessage ({ text, sourceMessageId, destinateMessageId, enableHistoricalMessaging }) {
    this.sourceMessageId = sourceMessageId
    this.destinateMessageId = destinateMessageId
    return this._client.sendMessageToPeer({ text }, destinateMessageId ? destinateMessageId.toString() : '', { enableHistoricalMessaging })
  }

  async sendChannelMessage (text, id, options) {
    if (!this.channels[id] || !this.channels[id].joined) return
    return this.channels[id].channel.sendMessage({ text }, options)
  }

  // send image
  async uploadImage (blob, peerId) {
    const mediaMessage = await this._client.createMediaMessageByUploading(blob, {
      messageType: 'IMAGE',
      fileName: 'agora.jpg',
      description: 'send image',
      thumbnail: blob
    })
    return this.client.sendMessageToPeer(mediaMessage, peerId)
  }
}
/* eslint-disable no-new */
